import React, { useEffect } from 'react';
import { useRenderPaymentMethods } from '../../../helpers/use-render-payment-methods.js';
import { useGetAltapaySessionData } from '../../../helpers/use-get-altapay-session-data.js';
import { Spinner } from '@crossroads/ui-components';
import cn from 'classnames';
import styles from 'shop-views/AltapayPaymentMethods.scss';

var PaymentMethods = _ref => {
  var client = _ref.client,
      isFree = _ref.isFree,
      setPaymentSelected = _ref.setPaymentSelected,
      customerQuery = _ref.customerQuery,
      scriptURL = _ref.scriptURL,
      storeInfoContext = _ref.storeInfoContext;

  var _useGetAltapaySession = useGetAltapaySessionData({
    client,
    isFree,
    scriptURL
  }),
      sessionId = _useGetAltapaySession.sessionId,
      token = _useGetAltapaySession.token,
      reFetchSession = _useGetAltapaySession.reFetchSession;

  var _useRenderPaymentMeth = useRenderPaymentMethods({
    token,
    sessionId,
    setPaymentSelected,
    client,
    customerQuery,
    storeInfoContext
  }),
      paymentMethodsLoading = _useRenderPaymentMeth.isLoading,
      paymentMethodsError = _useRenderPaymentMeth.paymentMethodsError;

  useEffect(() => {
    if (paymentMethodsError) {
      // This is to make sure the quote has had time to be re-opened again.
      setTimeout(() => {
        reFetchSession();
      }, 1500);
    }
  }, [paymentMethodsError]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React.createElement("div", {
    className: cn({
      [styles.padding]: paymentMethodsLoading
    }, styles.paymentMethodsWrapper)
  }, paymentMethodsLoading && /*#__PURE__*/React.createElement(Spinner, {
    className: "paymentSpinner",
    variant: "primary"
  }), /*#__PURE__*/React.createElement("div", {
    id: "paymentMethodsList",
    className: cn(styles.paymentMethodsList)
  }));
};

export { PaymentMethods };
//# sourceMappingURL=index.js.map
